export const CONTACT_BLOCK_PAGE_SIZE = 50;

/** Enable only after the contact-blocking migration is applied and verified. */
export function contactBlockingEnabled(): boolean {
  return process.env.NEXT_PUBLIC_CONTACT_BLOCKING_ENABLED === "true";
}

export function isContactId(value: unknown): value is string {
  return typeof value === "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
}

export type ContactBlock = {
  kind: "user" | "company";
  userId: string;
  companyId: string | null;
  side: "candidate" | "company" | null;
  displayName: string;
  createdAt: string;
};

export type ConversationBlockContext = {
  companyId: string;
  candidateUserId: string;
  side: "candidate" | "company";
  blockedByYou: boolean;
  canMessage: boolean;
};
